import { wealthProApi } from '../../redux/api';
import { socket } from '../../redux/socket';

const userClientTrackingEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["clientracker"]
}).injectEndpoints({
    endpoints: (builder) => ({
        fetchUserClientActivityTracker: builder.query({
            query: ({ masterAccountId }) => `/api/tracking/accounts/${masterAccountId}`,
            providesTags: (result, error, arg) => result
                ? [...result.map(({ userId }) => ({ type: 'clientracker', id: userId })), 'clientracker']
                : ['clientracker'],
            async onCacheEntryAdded({ masterAccountId }, { updateCachedData, cacheDataLoaded, cacheEntryRemoved }) {
                try {
                    await cacheDataLoaded;
                    socket.emit('join-masteraccount-room', masterAccountId);
                    socket.on('masteraccount:user:joined', (user) => {
                        updateCachedData((draft) => {
                            if (!draft.some(u => u.sub === user.sub))
                                return [...draft, user];
                        });
                    });
                    socket.on('masteraccount:user:left', (userId) => {
                        updateCachedData((draft) => {
                            return draft.filter(u => u.sub !== userId);
                        });
                    })
                }
                catch { }
                await cacheEntryRemoved;
                socket.emit('leave-masteraccount-room', masterAccountId);
                socket.off('masteraccount:user:joined');
                socket.off('masteraccount:user:left');
            }
        }),
    })
});

export const {
    useFetchUserClientActivityTrackerQuery
} = userClientTrackingEndpoints;